import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Card, CardContent, Typography, Grid, Box, CircularProgress } from '@mui/material';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarViewWeekIcon from '@mui/icons-material/CalendarViewWeek';

function ConsumoAguaIndicadores({ refresh }) {
  const { user } = useAuth();
  const [indicadores, setIndicadores] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (user?.tipo_usuario === 'admin' && user?.empresa_id) {
      params.empresa_id = user.empresa_id;
    }
    api.get('/consumo-agua/indicadores', { params })
      .then((response) => {
        setIndicadores(response.data);
      })
      .catch((error) => {
        console.error('Erro ao buscar indicadores:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [refresh, user]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
        <CircularProgress size={30} />
      </Box>
    );
  }

  const cards = [
    {
      titulo: 'Consumo Mensal',
      valor: indicadores?.consumo_mensal != null ? `${Number(indicadores.consumo_mensal).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} m³` : 'N/A',
      icone: <CalendarMonthIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    },
    {
      titulo: 'Média Diária',
      valor: indicadores?.media_diaria != null ? `${Number(indicadores.media_diaria).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} m³/dia` : 'N/A',
      icone: <WaterDropIcon sx={{ fontSize: 40, color: 'info.main' }} />,
    },
    {
      titulo: 'Média Semanal',
      valor: indicadores?.media_semanal != null ? `${Number(indicadores.media_semanal).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })} m³/dia` : 'N/A',
      icone: <CalendarViewWeekIcon sx={{ fontSize: 40, color: 'success.main' }} />,
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {cards.map((card, index) => (
        <Grid item xs={12} sm={4} key={index}>
          <Card sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
            <Box sx={{ mr: 2 }}>{card.icone}</Box>
            <CardContent sx={{ flex: 1, p: '0 !important' }}>
              <Typography variant="body2" color="text.secondary">
                {card.titulo}
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {card.valor}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default ConsumoAguaIndicadores;
